import { render, staticRenderFns } from "./Template8.vue?vue&type=template&id=d5a1f9da&scoped=true"
import script from "./Template8.vue?vue&type=script&lang=js"
export * from "./Template8.vue?vue&type=script&lang=js"
import style0 from "./Template8.vue?vue&type=style&index=0&id=d5a1f9da&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d5a1f9da",
  null
  
)

export default component.exports